var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('label', {
    staticClass: "typo__label"
  }, [_vm._v(_vm._s(this.$t('fields.provider')))]), _vm._v(" "), _c('Multiselect', {
    staticClass: "provider-combobox",
    attrs: {
      "options": _vm.options,
      "label": "name",
      "track-by": "name",
      "placeholder": _vm.$t('placeholder.select'),
      "select-label": _vm.$t('hints.select'),
      "deselect-label": _vm.$t('hints.deselect'),
      "selected-label": _vm.$t('hints.selected')
    },
    on: {
      "input": _vm.onInput
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  })], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1af36869","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/ProviderComboBox.vue
// module id = 1883
// module chunks = 0